module.exports = __webpack_public_path__ + "images/boxes/storyline_2-59dac4d74b09682a94eb3c1e80039aaf.webp";